<template>
  <div class="finance-bill-container">
    <div class="title">{{ title }}</div>
    <div class="container">
      <div class="slot-header" v-if="$slots.header">
        <slot name="header"></slot>
      </div>
      <slot></slot>
      <div class="slot-footer" v-if="$slots.footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: '',
  mixins: [],
  components: {},
  props: {
    title: String
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>

<style lang="scss">
.finance-bill-container {
  border: 1px solid #eef2f8;

  & + .finance-bill-container {
    margin-top: 16px;
  }

  > .title {
    border-bottom: 1px solid #eef2f8;
    line-height: 47px;
    padding-left: 16px;
    font-size: 14px;
    font-weight: bold;
    color: #394668;
  }

  > .container {
    padding: 0px 16px 0px 16px;

    > .slot-header {
      line-height: 32px;
      padding: 16px 0;
      overflow: hidden;

      .bill-base-msg {
        overflow: hidden;
        line-height: 32px;
        font-size: 12px;
        padding-left: 10px;
        background: rgba(13, 154, 224, 0.15);
        color: #6c757d;
        // margin-top: 16px;

        .icon {
          float: left;
          font-size: 12px;
          color: #0d9ae0;
        }

        .order-num {
          float: left;
          max-width: 200px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-left: 10px;

          .num {
            color: #0d9ae0;
          }
        }

        .copy {
          float: left;
          margin-left: 10px;
          color: #0d9ae0;
          text-decoration: underline;
          cursor: pointer;
        }

        .tips {
          float: left;
          margin-left: 10px;
          max-width: 50%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .el-button {
        float: left;
      }

      .money {
        float: right;
        font-size: 12px;
        color: #636e78;
        font-weight: bold;
        & + .money {
          margin-right: 15px;
        }
        .key {
          float: left;
          max-width: 150px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .val {
          color: #0d9ae0;
          float: left;
        }
      }
    }

    > .slot-footer {
      padding: 16px 0;
      overflow: hidden;
      .el-checkbox-group {
        float: left;

        .el-checkbox {
          &:first-child {
            margin-right: 6px;
          }
        }
      }

      .money {
        overflow: hidden;
        line-height: 32px;
        font-size: 12px;
        float: left;
        margin-left: 24px;
        color: #636e78;
        font-weight: bold;

        .key {
          float: left;
        }

        .val {
          float: left;
          color: #0d9ae0;
        }
      }

      .check-balance {
        text-decoration: underline;
        display: inline-block;
        pointer-events: none;
      }
    }
  }
}
</style>
